import { createSlice } from "@reduxjs/toolkit";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { errorHandler } from "../../../helpers/errorHandler";
import { Call, CallWithFormData } from "../../../helpers/fetch";
import { shoppingCartApp } from "./ShoppingCartApp";
import Swal from "sweetalert2";

const getJsonReferences = () => {
    try {
        const jsonObj =
            JSON.parse(localStorage.getItem("report-cache")) || null;
        return jsonObj;
    } catch (error) {
        localStorage.removeItem("report-cache");
        return null;
    }
};

const initialState = {
    reportData: getJsonReferences(),
};

export const genericReports = createSlice({
    name: "genericReports",
    initialState,
    reducers: {
        setReportData: (state, action) => {
            state.reportData = action.payload;
        },
    },
});

export const { setReportData } = genericReports.actions;
export default genericReports.reducer;

// Thunks

export const startOpenPDFReport = (values, id) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        window.open(
            `${values.url}/${id}`,
            values.title,
            "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=1080, height=700"
        );
        dispatch(stopUILoading());
    };
};

export const startGetReportData = (url, id) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        let resp = await Call(`${url}/${id}`, "POST");

        if (resp.success) {
            dispatch(setReportData(resp.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startGetPostReportData = (
    { url, id, session, curriculum_level, skip_tutor_validation = 0 },
    setSkippedTutorValidation = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        console.log(curriculum_level);

        const params = {
            academic_record_id: id,
            skip_tutor_validation: Number(skip_tutor_validation),
        };

        let resp = await Call(`${url}`, "POST", params);

        if (resp.success) {
            dispatch(setReportData(resp.success));
        } else {
            const error = resp.error;
            if (error?.event === "NO_TUTOR" && !skip_tutor_validation) {
                const studentNumber = error.metadata?.student_number;

                if (session === "operator") {
                    Swal.fire({
                        icon: "error",
                        title: "Falta información del tutor",
                        text: "No se encontró información del tutor del alumno. Por favor, captura los datos del tutor.",
                        confirmButtonText: "Ir al perfil del alumno",
                        showDenyButton: ![
                            "Bachillerato",
                            "Licenciatura",
                        ].includes(curriculum_level), // solo se puede omitir si no es bachillerato o licenciatura
                        denyButtonText: "Omitir datos del tutor",
                        denyButtonColor: "gray",

                        reverseButtons: true,
                        customClass: {
                            confirmButton: "confirm-button-class",
                        },
                        didOpen: () => {
                            const confirmButton = document.querySelector(
                                ".confirm-button-class"
                            );

                            if (confirmButton) {
                                confirmButton.style.marginLeft = "20px";
                            }
                        },
                    }).then((result) => {
                        if (result.isDenied) {
                            //? Vuelve a ejecutar la misma acción, pero omitiendo validación del tutor
                            setSkippedTutorValidation(true);

                            dispatch(
                                startGetPostReportData({
                                    url,
                                    id,
                                    session,
                                    curriculum_level,
                                    skip_tutor_validation: 1,
                                })
                            );
                        } else {
                            if (studentNumber) {
                                // Redirige a la ruta relativa con el tab de tutor y familiares
                                window.location.href = `/app/students/form/${studentNumber}?tab=Tutor y familiares`;
                            }
                        }
                    });
                } else if (session === "student") {
                    Swal.fire({
                        icon: "warning",
                        title: "Falta información del tutor",
                        text: "No se encontró información del tutor en tu registro. Por favor, acude con un asesor para que te apoye a capturar los datos.",
                        showConfirmButton: false, // sin botón
                        allowOutsideClick: false, // no cerrar al dar click fuera
                        allowEscapeKey: false, // no cerrar con ESC
                        allowEnterKey: false, // no cerrar con ENTER
                        showCloseButton: false, // sin botón de X
                        backdrop: true, // bloquea la pantalla detrás
                        didOpen: () => {
                            // bloquea por completo
                            Swal.disableButtons();
                        },
                    });
                }
            } else {
                errorHandler(resp);
            }
        }

        dispatch(stopUILoading());
    };
};

export const startGetReferences = (
    student,
    shopingCart,
    goToReferences,
    toInvoice
) => {
    return async (dispatch) => {
        const formData = new FormData();

        formData.append("student", JSON.stringify(student));
        formData.append("shopingCart", JSON.stringify(shopingCart));
        if (toInvoice) {
            formData.append("toInvoice", toInvoice);
        }

        const resp = await CallWithFormData(
            `services/payments/generate/references`,
            "POST",
            formData
        );

        if (resp.success) {
            localStorage.setItem("report-cache", JSON.stringify(resp.success));
            dispatch(setReportData(resp.success));
            goToReferences();
        }
    };
};
